// extracted by mini-css-extract-plugin
export var copyableField = "_ok-4";
export var customerBadge = "_ok-0";
export var customerInfoTitle = "_ok-2";
export var details = "_ok-1";
export var dropdownContainer = "_ok-5";
export var dropdownImage = "_ok-6";
export var editAssigneeForm = "_ok-a";
export var editButton = "_ok-3";
export var email = "_ok-7";
export var hidden = "_ok-d";
export var input = "_ok-8";
export var saveButton = "_ok-b";
export var shopifyIcon = "_ok-c";
export var suggestionBadge = "_ok-e";
export var suggestionText = "_ok-f";
export var username = "_ok-9";